import React, { useState } from 'react';
import Notification from './interfaces/notification';
import { ConfigType } from './config';
import { fetchConfig } from './services';

export interface ContextType {
    page: number,
    setPage: (page: number) => void,
    setFirstPage: () => void,
    limit: number,
    setLimit: (limit: number) => void,
    enabled: boolean,
    setEnabled: (enabled: boolean) => void,
    helpURL: string,
    setHelpURL: (link: string) => void,
    numColumn: number,
    setNumColumn: (numColumn: number) => void,
    numRow: number,
    setNumRow: (lnumRow: number) => void,
    teamMembers: Array<any>,
    setTeamMembers: (arr: Array<any>) => void
    notification: Notification | null,
    setNotification: (notification: Notification) => void,
    siteConfig: ConfigType
    userId: string,
    setUserId: (id: string) => void,
    userName: string,
    setUserName: (value: string) => void,
}

const initialPage = 1;
const itemsPerPage = 10;

export const Context = React.createContext<ContextType>({
    page: initialPage,
    setPage: (page: number) => {},
    setFirstPage: () => {},
    limit: itemsPerPage,
    setLimit: (limit: number) => {},
    enabled: false,
    setEnabled: (enabled: boolean) => {},
    helpURL: '',
    setHelpURL: (link: string) => {},
    numColumn: 4,
    setNumColumn: (numColumn: number) => {},
    numRow: 4,
    setNumRow: (lnumRow: number) => {},

    teamMembers: [],
    setTeamMembers: (arr: Array<any>) => {},

    notification: null,
    setNotification: (notification: Notification) => {},

    userId: '',
    setUserId: (id: string) => {},
    userName: '',
    setUserName: (value: string) => {},

    siteConfig: null
})

const ContextWrap = (props: {siteConfig: ConfigType | null, children: React.ReactNode}) => {

    const [page, setPageLocal] = useState<number>(initialPage)

    const setFirstPage = () => {
          setPageLocal(initialPage)
    }

    const setPage = (page: number) => {
          setPageLocal(page)
    }

    const [limit, setLimitLocal] = useState<number>(itemsPerPage)

    const setLimit = (limit: number) => {
          setLimitLocal(limit)
    }

    const [enabled, setEnabledLocal] = useState<boolean>(false)

    const setEnabled = (value: boolean) => {
          setEnabledLocal(value)
    }

    const [numColumn, setNumColumnLocal] = useState<number>(2)

    const setNumColumn = (value: number) => {
      setNumColumnLocal(value)
    }

    const [numRow, setNumRowLocal] = useState<number>(2)

    const setNumRow = (value: number) => {
      setNumRowLocal(value)
    }

    const [teamMembers, setTeamMembersLocal] = useState<Array<any>>([])

    const setTeamMembers = (arr: Array<any>) => {
      setTeamMembersLocal(arr)
    }

    const [userId, setUserIdLocal] = useState<string>('0');

    const setUserId = (value: string) => {
      setUserIdLocal(value)
    }

    const [userName, setUserNameLocal] = useState<string>('');

    const setUserName = (value: string) => {
      setUserNameLocal(value)
    }

    const [notification, setNotificationLocal] = useState<Notification>(null);

    const setNotification = (value: Notification) => {
      setNotificationLocal(value)
    }

    const [helpURL, setHelpURLLocal] = useState<string>('')

    const setHelpURL = (value: string) => {
      setHelpURLLocal(value);
    }

    const [siteConfig, setSiteConfigLocal] = useState<ConfigType>(props.siteConfig);

    fetchConfig(siteConfig['API_URL']).
      then(json => {
        setEnabled(json.config.isSpsEnabled);
        setNumColumn(json.config.numColumn);
        setNumRow(json.config.numRow);

        if (json.config.helpURL) {
          setHelpURL(json.config.helpURL);
        }

      });

    return (<Context.Provider 
                value={{
                    page,
                    setPage,
                    setFirstPage,
                    limit,
                    setLimit,
                    enabled,
                    setEnabled,
                    helpURL,
                    setHelpURL,
                    numColumn,
                    setNumColumn,
                    numRow,
                    setNumRow,

                    teamMembers,
                    setTeamMembers,

                    notification,
                    setNotification,
                    siteConfig,

                    userId,
                    setUserId,
                    userName,
                    setUserName
                }}>
                    {props.children}
            </Context.Provider>)
}

export { ContextWrap }
